import React from "react";
import AddLot from "containers/Admin/AddLot";
function EditLot(props) {
  return <AddLot {...props} mode="update" />;
}

export default EditLot;
